module.exports = ".doc-list {\r\n    line-height : 30px;\r\n    cursor : pointer;\r\n    vertical-align:middle;\r\n    padding : 0 5px\r\n}\r\n.outList {\r\n    background-color:  #ffffff;\r\n    color : #444\r\n}\r\n.hoverList {\r\n    background-color:  #09b9ac;\r\n    color : #fff\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/section/user/user-detail/user-detail.component.css
// module id = ./src/app/section/user/user-detail/user-detail.component.css
// module chunks = main